var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9568 4.16043C11.2874 3.94652 11.7127 3.94652 12.0433 4.16043L20.5433 9.66043C20.9154 9.9012 21.0846 10.3582 20.9591 10.7832C20.8335 11.2083 20.4432 11.5 20 11.5H19V18.5C19 19.0523 18.5523 19.5 18 19.5H14C13.4477 19.5 13 19.0523 13 18.5V14.5H10V18.5C10 19.0523 9.5523 19.5 9.00002 19.5H5.00002C4.44774 19.5 4.00002 19.0523 4.00002 18.5V11.5H3.00002C2.55682 11.5 2.16649 11.2083 2.04097 10.7832C1.91544 10.3582 2.08467 9.9012 2.45677 9.66043L10.9568 4.16043ZM5.44015 10.1122C5.78682 10.4718 6.00002 10.961 6.00002 11.5V17.5H8.00002V14.5C8.00002 13.3954 8.89545 12.5 10 12.5H13C14.1046 12.5 15 13.3954 15 14.5V17.5H17V11.5C17 10.961 17.2132 10.4718 17.5599 10.1122L11.5 6.19109L5.44015 10.1122Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.298360b328b0f395adeff1f1a84d15db.svg";
export { ForwardRef as ReactComponent };